import { PROJECT_TYPES } from "src/constants";

const isDraftProject = (project) =>
  project?.type === PROJECT_TYPES.AGRO_DRAFT ||
  project?.type === PROJECT_TYPES.CARBON_DRAFT;

const isAgroDraft = (project) =>
  project?.type === PROJECT_TYPES.AGRO_DRAFT;

const isCarbonDraft = (project) =>
  project?.type === PROJECT_TYPES.CARBON_DRAFT;

const isUnapprovedProject = (project) =>
  project?.type === PROJECT_TYPES.AGRO_UNAPPROVED ||
  project?.type === PROJECT_TYPES.CARBON_UNAPPROVED;

const isAgroUnapproved = (project) =>
  project?.type === PROJECT_TYPES.AGRO_UNAPPROVED;

const isCarbonUnapproved = (project) =>
  project?.type === PROJECT_TYPES.CARBON_UNAPPROVED;

const isAgroProject = (project) =>
  project?.type === PROJECT_TYPES.AGROFORESTRY;

const isCarbonProject = (project) =>
  project?.type === PROJECT_TYPES.CARBON_CREDIT;

const isAgroType = (project) =>
  isAgroDraft(project) || isAgroUnapproved(project) || isAgroProject(project);

const isCarbonType = (project) =>
  isCarbonDraft(project) || isCarbonUnapproved(project) || isCarbonProject(project);

const resolveProjectData = (project) => {
  if (!project) return null;
  return project;
};

const resolveCarbonTimeline = (project) => {
  if (!project) return null;
  if (project?.data?.timeline) return project.data.timeline;
  // Legacy detail-page callers already pass the inner project data object.
  return resolveProjectData(project)?.timeline || null;
};

const getCarbonTimelineHorizon = (project) => {
  const horizon = Number(resolveCarbonTimeline(project)?.modeling_horizon_years);
  return Number.isInteger(horizon) && horizon > 0 ? horizon : 0;
};

const getCarbonTimelineYears = (project) => {
  const timeline = resolveCarbonTimeline(project);
  const horizon = Number(timeline?.modeling_horizon_years);
  const startYear = Number(timeline?.project_start_year);
  if (
    !Number.isInteger(horizon) ||
    horizon <= 0 ||
    !Number.isInteger(startYear)
  ) {
    return [];
  }
  return Array.from({ length: horizon }, (_, i) => startYear + i);
};

export {
  isDraftProject,
  isAgroDraft,
  isCarbonDraft,
  isUnapprovedProject,
  isAgroUnapproved,
  isCarbonUnapproved,
  isAgroProject,
  isCarbonProject,
  isAgroType,
  isCarbonType,
  resolveProjectData,
  resolveCarbonTimeline,
  getCarbonTimelineHorizon,
  getCarbonTimelineYears,
};
